module.exports = __webpack_public_path__ + "img/search2.7a670223.png";